class FancySupport extends HTMLElement {
  constructor() {
      super();
      
      this.fancySupport = document.getElementById('fancy-support');
      this.fancySupportOpener = document.getElementById('fancy-support-opener');
      if(this.fancySupportOpener != null){
            this.header = document.querySelector('sticky-header');
            this.onBodyClick = this.handleBodyClick.bind(this);
            
            this.fancySupport.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
            this.querySelectorAll('button[type="button"]').forEach((closeButton) => 
                closeButton.addEventListener('click', this.close.bind(this))
            );
            
            this.fancySupportOpener.addEventListener('click', this.open.bind(this));
      }
  }
  
  open() {
      console.log('open fancy support!');
      this.fancySupport.classList.add('animate', 'active');
      console.log('active');
      this.fancySupport.addEventListener(
          'transitionend',
          () => {
              this.fancySupport.focus();
              trapFocus(this.fancySupport);
          },
          { once: true }
      );
      
      document.body.addEventListener('click', this.onBodyClick);
  }
  
  close() {
      this.fancySupport.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
      
      removeTrapFocus(this.activeElement);
  }
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  
  handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.fancySupportOpener && !this.fancySupportOpener.contains(target) &&
          target !== this.fancySupport && !this.fancySupport.contains(target)) {
          const disclosure = target.closest('details-disclosure, header-menu');
          this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
          this.close();
      }
  }
  
  setActiveElement(element) {
      this.activeElement = element;
  }
}

customElements.define('fancy-support', FancySupport);
